module.exports = __webpack_public_path__ + "static/media/arrow-down-disabled.6b7692ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down-disabled.svg
// module id = 144
// module chunks = 0